import { useState } from 'react'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import SelectSearch from 'react-select'
import { getPrestacionSelected } from "../../Api";
const Search = ({filters, setData, onChange, loadData, downloadExcel}) => {
  const [options, setOptions] = useState([]);
  
  const handleChange = (newValue, actionMeta) => {
    setData('codigo_prestacion', newValue.value);
  };
  const selectPrestacion = async (value = "") => {
    if (value.length >= 3) {
      const _response = await getPrestacionSelected({ search: value });
      if (_response.status) {
        setOptions(_response.data);
      }
    }
  }
  const handleInputChange = (inputValue, actionMeta) => {
    selectPrestacion(inputValue);
  };
  return (
    <div className="row">
      <div className="card col-md-12">
        <div className="card-body">
          {/* Proceso de Liquidación
            <span className='indicator-progress' style={{display: 'block'}}>
              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
            </span> */}
          <div className="row">
            <div className="col-md-2">
              <label className="fs-4 fw-bold">ID Clínica</label>
              <input
                name="rolclinica"
                className="form-control"
                type="text"
                placeholder="ID Clínica"
                value={filters.rolclinica}
                onChange={onChange}
              />
            </div>
            <div className="col-md-2">
              <label className="fs-4 fw-bold">Rut Paciente</label>
              <input
                name="paciente"
                className="form-control"
                type="text"
                placeholder="Paciente"
                value={filters.paciente}
                onChange={onChange}
              />
            </div>
            <div className="col-md-2">
              <label className="fs-4 fw-bold">Nombre Paciente</label>
              <input
                name="nombrepaciente"
                className="form-control"
                type="text"
                placeholder="Nombre Paciente"
                value={filters.nombrepaciente}
                onChange={onChange}
              />
            </div>
            <div className="col-md-3">
              <label className="fs-4 fw-bold">Rol Profesional</label>
              <select className="form-select form-select-white" aria-label="..." name="rolprof" value={filters.rolprof} onChange={onChange}>
                <option value="-1" disabled="">Seleccione...</option>
                <option value="0">Todos</option>
                <option value="CI">CIRUJANO</option>
                <option value="AY1">AYUDANTE 1</option>
                <option value="AY2">AYUDANTE 2</option>
                <option value="MAT">MATRONA</option>
                <option value="v">VISITA HOSPITALARIA</option>
              </select>
            </div>
            <div className="col-md-3">
              <label className="fs-4 fw-bold">Prestación</label>
              {/* <select className="form-select form-select-white" aria-label="..." name="codigo_prestacion" value={filters.codigo_prestacion} onChange={onChange}>
              </select> */}
              <SelectSearch
                options={options}
                onChange={handleChange}
                onInputChange={handleInputChange}
                noOptionsMessage={() => "Ingrese al menos 3 caracteres para buscar"}
                placeholder="Seleccione..."
              />
            </div>
          </div>
          <div className="row mt-5">
            <div className="col-md-3">
              <label className="fs-4 fw-bold">Fecha de Alta Desde *</label>
              <input
                name="start_date"
                className="form-control"
                type="month"
                value={filters.start_date}
                onChange={onChange}
              />
            </div>
            <div className="col-md-3">
              <label className="fs-4 fw-bold">Fecha de Alta Hasta *</label>
              <input
                name="finish_date"
                className="form-control"
                type="month"
                value={filters.finish_date}
                onChange={onChange}
              />
            </div>
            <div className="col-md-3">
              <label className="fs-4 fw-bold">Estado</label>
              <select className="form-select form-select-white" aria-label="..." name="estado" value={filters.estado} onChange={onChange}>
                <option value="-1" disabled="">Seleccione...</option>
                <option value="0">Todos</option>
                <option value="5">FINALIZADAS</option>
                <option value="6">PROCESO ISAPRE</option>
                <option value="7">EN COBRO PACIENTE</option>
                <option value="9">PAGADO</option>
                <option value="8">TRAMITE CLINICA</option>
                <option value="10">PROCESO COBRANZA</option>
              </select>
            </div>
            <div className="col-md-12 col-lg-12 col-xl-3 col-xxl-3">
              <div className='mt-7 text-center'>
                <button type='button' className='btn btn-primaryamsm' style={{ marginRight: '10px' }} onClick={() => loadData()}>
                  Buscar
                </button>
                <button className="icon-button btn btn-outline btn-outline-primaryamsm btn-active-light-primary" onClick={() => downloadExcel()}>
                  <div className="icon-container">
                    <span>Excel</span>
                    <img src={toAbsoluteUrl('/media/icons/732220.png')} alt="Descarga Excel" />
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Search;
